import Skeleton from "@mui/material/Skeleton"

import Column from "../../../../../../common/components/Column"

export default function ActivitySkeleton() {
  return (
    <Column sx={{ gap: 4 }}>
      {Array.from({ length: 5 }).map((_, i) => (
        <Skeleton
          key={i}
          variant="rectangular"
          width="100%"
          height={72}
          sx={{ borderRadius: 1 }}
        />
      ))}
    </Column>
  )
}
